import Vue from "vue"
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

function loadSurveyLanguages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const surveyLanguage = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      surveyLanguage[locale] = locales(key)
    }
  })
  return surveyLanguage
}

const internationalizationObject = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadSurveyLanguages(),
})

export default internationalizationObject

